<div class="row">
  
    <div class="col-12 col-md-8" *ngIf="formGroup.controls['oborDeliveryEligibility'].enabled" >
        <nsc-form-field-toggle  
        idx="obor_eligibility" 
        controlName='oborDeliveryEligibility' 
        label="{{data.schoolProfile.oborDeliveryEligibilityQuestion}}"
        [group]="formGroup">
        </nsc-form-field-toggle>
      </div>
      
  <div class="col-12 col-md-8" *ngIf="formGroup.controls['department'].enabled">
    <nsc-form-field-select
      idx="recepientselect_department"
      controlName="department"
      placeholder="Department"
      [group]="formGroup"
      [selectObjects]="values.departments$.value"></nsc-form-field-select>
  </div>

  <div class="col-12 col-md-4" *ngIf="formGroup.controls['lsacAccountNumber'].enabled">
    <nsc-form-field-input
      idx="lsac_id"
      controlName="lsacAccountNumber"
      hint="Enter LSAC ID 'Lxxxxxxxx'"
      maxlength="9"
      placeholder="Enter {{ content.labelLsacAccountNumber }}"
      [group]="formGroup"
      [mask]="masks.lsacAccountNumber"></nsc-form-field-input>
  </div>

  <div class="col-12"></div>

  <div class="col-12 col-md-4" *ngIf="formGroup.controls['aamcAccountNumber'].enabled">
    <nsc-form-field-input
      idx="amcas_id"
      controlName="aamcAccountNumber"
      hint="(8 digits)"
      maxlength="8"
      placeholder="Enter {{ content.labelAamcAccountNumber }}"
      [group]="formGroup"
      [mask]="masks.aamcAccountNumber"></nsc-form-field-input>
  </div>
  <div class="col-12 col-md-4" *ngIf="formGroup.controls['amcasTranscriptIdNumber'].enabled">
    <nsc-form-field-input
      idx="amcas_number"
      controlName="amcasTranscriptIdNumber"
      hint="(7 digits)"
      maxlength="7"
      placeholder="Enter {{ content.labelAmcasTranscriptIdNumber }}"
      [group]="formGroup"
      [mask]="masks.amcasTranscriptIdNumber"></nsc-form-field-input>
  </div>

  <div class="col-12"></div>

  <div class="col-12 col-md-4" *ngIf="formGroup.controls['casId'].enabled">
    <div class="row nsc-row--12">
      <div class="col">
        <nsc-form-field-input
          idx="cas_id"
          controlName="casId"
          maxlength="60"
          placeholder="Enter {{ content.labelCasId }}"
          [group]="formGroup"></nsc-form-field-input>
      </div>
      <div class="col-auto">
        <br />
        <mat-icon
          role="button"
          tabindex="0"
          aria-hidden="false"
          aria-label="Help"
          (click)="openDialog()"
          (keyup.enter)="openDialog()"
          (keyup.space)="openDialog()">help</mat-icon>        
      </div>
    </div>
  </div>

  <div class="col-12"></div>

  <div class="col-12 col-md-8" *ngIf="formGroup.controls['sendElectronically'].enabled">
      <nsc-form-field-toggle
        idx="send_electronically"
        controlName="sendElectronically"
        label="{{ content.sendElectronicallyQuestion }}"
        valueNo="{{values.no}}"
        valueYes="{{values.yes}}"
        [disabled]="formGroup.controls['sendElectronically'].disabled"
        [group]="formGroup"></nsc-form-field-toggle>
  </div>

  <div class="col-12"></div>

  <div class="col-12 col-md-8" *ngIf="formGroup.controls['sendElectronically'].enabled && formGroup.controls['sendElectronically'].value == values.yes">
    <nsc-form-field-confirm
    idx="recipientselect_email"
    autocomplete="email"
    controlNameConfirm="emailConfirm"
    controlNamePrimary="emailPrimary"
    placeholder="Email Address"
    [group]="formGroup"></nsc-form-field-confirm>
  </div>

  <div class="col-12"></div>

  <div class="col-12 col-md-8 col-lg-4" *ngIf="formGroup.controls['departmentNotInList'].enabled">
    <nsc-form-field-input
      idx="notinlist"
      controlName="departmentNotInList"
      maxlength="40"
      placeholder="{{ content.labelDepartment }}"
      [group]="formGroup"
      [required]="content.requireDepartment"></nsc-form-field-input>
  </div>

</div>
